import data from "@/content/testimonials.json";
import Reveal from "@/components/home/Reveal";
import TestimonialCard from "@/components/home/TestimonialCard";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

// Oculta hasta que existan testimonios reales (content/testimonials.json → visible: true)
export const Testimonials = () => {
  const items = data.items.filter((t) => t.name && t.quote);
  if (!data.visible || items.length === 0) return null;
  return (
    <section id="testimonios" className="mt-section bg-white" data-testid="testimonials-section">
      <div className="mt-container">
        <Reveal className="max-w-2xl">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl leading-tight">Restauranteros que ya se quedaron con el 100%.</h2>
        </Reveal>
        <Reveal delay={120} className="mt-10">
          <Carousel opts={{ align: "start", loop: true }} className="px-2">
            <CarouselContent>
              {items.map((t, i) => (
                <CarouselItem key={i} className="md:basis-1/2 lg:basis-1/3"><TestimonialCard {...t} /></CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="-left-3" /><CarouselNext className="-right-3" />
          </Carousel>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
